import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useApi from "../../helpers/apiHelper/requestHelper";
import Table from "../sharedPages/CommonComponents/Table";

const mapParticipantsToTableData = (apiResponse) => {
  return apiResponse.map((item) => {
    let connected = "";
    let className = "";
    if (item?.binanceCredentials?.isConnected) {
      connected = "Binance";
      className = "greenText";
    } else if (item?.bybitCredentials?.isConnected) {
      connected = "Bybit";
      className = "greenText";
    }

    return {
      ...item,
      connected: {
        value: connected,
        className,
      },
    };
  });
};

function MemberListining() {
  const { communityId } = useParams();
  const [allParticipants, setAllParticipants] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const paginatedData = allParticipants.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const api = useApi();

  const columns = [
    {
      label: "Email",
      key: "email",
      width: "25%",
      type: "profile",
    },
    { label: "Connected", key: "connected", width: "15%" },
  ];

  const getAllCommunities = async () => {
    const response = await api("post", "authorizeSuperAdmin/allCommunities", {
      communityId,
    });
    const allParticipants =
      response?.data?.communities?.[0]?.participants || [];
    const data = mapParticipantsToTableData(allParticipants);
    setAllParticipants(data);
  };

  useEffect(() => {
    getAllCommunities();
  }, []);

  return (
    <div className="AccountSettingPage">
      <Table
        columns={columns}
        data={paginatedData}
        currentPage={currentPage}
        totalPages={Math.ceil(allParticipants.length / itemsPerPage)}
        onPageChange={setCurrentPage}
        noDataMessage={"No Participent in this Community"}
      />
    </div>
  );
}

export default MemberListining;
